import { render, staticRenderFns } from "./Standup.vue?vue&type=template&id=72788671&scoped=true&"
import script from "./Standup.vue?vue&type=script&lang=js&"
export * from "./Standup.vue?vue&type=script&lang=js&"
import style0 from "./Standup.vue?vue&type=style&index=0&id=72788671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72788671",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72788671')) {
      api.createRecord('72788671', component.options)
    } else {
      api.reload('72788671', component.options)
    }
    module.hot.accept("./Standup.vue?vue&type=template&id=72788671&scoped=true&", function () {
      api.rerender('72788671', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Standup.vue"
export default component.exports